import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-table-pagination',
  standalone: true,
  imports: [],
  templateUrl: './table-pagination.component.html',
  styleUrl: './table-pagination.component.scss'
})
export class TablePaginationComponent implements OnInit, OnChanges {
  @Input() totalItems = 0;
  @Input() itemsPerPage = 1;
  @Output() pageChanged = new EventEmitter<number>();

  currentPage = 1;
  totalPages = 0;
  visiblePageNumbers: number[] = [];
  startPage = 1;
  endPage = 5;

  ngOnInit() {
    this.calculateTotalPages();
    this.updateVisiblePageNumbers();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['totalItems'] || changes['itemsPerPage']) {
      this.calculateTotalPages();
      this.updateVisiblePageNumbers();
    }
  }

  calculateTotalPages() {
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
  }

  updateVisiblePageNumbers() {
    this.visiblePageNumbers = [];
    for (let i = this.startPage; i <= this.endPage && i <= this.totalPages; i++) {
      this.visiblePageNumbers.push(i);
    }
  }

  previousPages() {
    if (this.startPage > 1) {
      this.startPage -= 3;
      this.endPage -= 3;
      this.updateVisiblePageNumbers();
    }
  }

  nextPages() {
    if (this.endPage < this.totalPages) {
      this.startPage += 3;
      this.endPage = Math.min(this.endPage + 3, this.totalPages);
      this.updateVisiblePageNumbers();
    }
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.pageChanged.emit(this.currentPage);
  }
}

